import script from "./MainWechatMerchantSegView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainWechatMerchantSegView.vue?vue&type=script&setup=true&lang=ts"

import "./MainWechatMerchantSegView.vue?vue&type=style&index=0&id=0f5b61d8&scoped=true&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f5b61d8"]])

export default __exports__